module.exports = __webpack_public_path__ + "static/media/scatter_plot.d510e4c9.svg";